import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateNegHit extends PlayerState {
    tween: Phaser.Tweens.Tween;
    spin: boolean;
    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.NegHit);
        this.spin = false;
    }

    beginState(spin = false): void {
        super.beginState();
        this.spin = spin;
        this.player._gameScene.ui.playHitGlow();
        this.startTimer(spin ? 1 : 0.3);
        if (spin) {
            this.tween = this.scene.tweens.add({
                targets: this.player.img, 
                angle: 360,
                duration: 1000,
            });
        }
    }

    shutDown(): void {
        if (this.tween) this.tween.stop();
        this.player.img.angle = 0;
        this.spin = false;
        super.shutDown();
    }

    timerCallback(): void {
        this.player.img.angle = 0;
        this.spin = false;

        super.timerCallback();
        this.player.evalFlight();
    }
}